export enum LineStyle {
  Line = 'line',
  Dashed = 'dashed',
  Dotted = 'dotted',
}
